export var primaryCallingCodes = function(strictLocalize) {
    return [
        [
            strictLocalize({
                id: "Ork865",
                defaultMessage: [
                    {
                        type: 0,
                        value: "United States of America"
                    }
                ]
            }),
            "+1"
        ],
        [
            strictLocalize({
                id: "NRvxo9",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Canada"
                    }
                ]
            }),
            "+1"
        ],
        [
            strictLocalize({
                id: "e/cBN/",
                defaultMessage: [
                    {
                        type: 0,
                        value: "United Kingdom"
                    }
                ]
            }),
            "+44"
        ]
    ];
};
export var secondaryCallingCodes = function(strictLocalize) {
    return [
        [
            strictLocalize({
                id: "zPDpum",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Netherlands"
                    }
                ]
            }),
            "+31"
        ],
        [
            strictLocalize({
                id: "Cpr6vw",
                defaultMessage: [
                    {
                        type: 0,
                        value: "France"
                    }
                ]
            }),
            "+33"
        ],
        [
            strictLocalize({
                id: "wCeYIy",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Germany"
                    }
                ]
            }),
            "+49"
        ],
        [
            strictLocalize({
                id: "Wyj3zx",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Italy"
                    }
                ]
            }),
            "+39"
        ],
        [
            strictLocalize({
                id: "O23YTi",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Spain"
                    }
                ]
            }),
            "+34"
        ],
        [
            strictLocalize({
                id: "hsAQ3a",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Austria"
                    }
                ]
            }),
            "+43"
        ],
        [
            strictLocalize({
                id: "1odLN1",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Belgium"
                    }
                ]
            }),
            "+32"
        ],
        [
            strictLocalize({
                id: "DbRUc4",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Ireland"
                    }
                ]
            }),
            "+353"
        ],
        [
            strictLocalize({
                id: "fEt9l3",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Luxembourg"
                    }
                ]
            }),
            "+352"
        ],
        [
            strictLocalize({
                id: "KIczXx",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Australia"
                    }
                ]
            }),
            "+61"
        ],
        [
            strictLocalize({
                id: "rxDFa0",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Finland"
                    }
                ]
            }),
            "+358"
        ],
        [
            strictLocalize({
                id: "CLfdti",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Denmark"
                    }
                ]
            }),
            "+45"
        ],
        [
            strictLocalize({
                id: "6zhC/J",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sweden"
                    }
                ]
            }),
            "+46"
        ],
        [
            strictLocalize({
                id: "p1lMN4",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Norway"
                    }
                ]
            }),
            "+47"
        ],
        [
            strictLocalize({
                id: "/OH3C0",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Switzerland"
                    }
                ]
            }),
            "+41"
        ],
        [
            strictLocalize({
                id: "B2jMs3",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Northern Ireland"
                    }
                ]
            }),
            "+44 28"
        ],
        [
            strictLocalize({
                id: "1o+V7l",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Portugal"
                    }
                ]
            }),
            "+351"
        ]
    ];
};
export var callingCodes = function(strictLocalize) {
    return [
        [
            strictLocalize({
                id: "4RTBzG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Zimbabwe"
                    }
                ]
            }),
            "+63"
        ],
        [
            strictLocalize({
                id: "nizvFY",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Bahamas"
                    }
                ]
            }),
            "+1 242"
        ],
        [
            strictLocalize({
                id: "IUbr2V",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Barbados"
                    }
                ]
            }),
            "+1 246"
        ],
        [
            strictLocalize({
                id: "3U+IrH",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Anguilla"
                    }
                ]
            }),
            "+1 264"
        ],
        [
            strictLocalize({
                id: "21bo/G",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Antigua and Barbuda"
                    }
                ]
            }),
            "+1 268"
        ],
        [
            strictLocalize({
                id: "4pkmlv",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Barbuda"
                    }
                ]
            }),
            "+1 268"
        ],
        [
            strictLocalize({
                id: "1ug57S",
                defaultMessage: [
                    {
                        type: 0,
                        value: "British Virgin Islands"
                    }
                ]
            }),
            "+1 284"
        ],
        [
            strictLocalize({
                id: "5sfjVw",
                defaultMessage: [
                    {
                        type: 0,
                        value: "US Virgin Islands"
                    }
                ]
            }),
            "+1 340"
        ],
        [
            strictLocalize({
                id: "QACzsU",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cayman Islands"
                    }
                ]
            }),
            "+1 345"
        ],
        [
            strictLocalize({
                id: "JGdLnb",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Bermuda"
                    }
                ]
            }),
            "+1 441"
        ],
        [
            strictLocalize({
                id: "Oyfaai",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Grenada"
                    }
                ]
            }),
            "+1 473"
        ],
        [
            strictLocalize({
                id: "E/zO2j",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Turks and Caicos Islands"
                    }
                ]
            }),
            "+1 649"
        ],
        [
            strictLocalize({
                id: "C98eRy",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Montserrat"
                    }
                ]
            }),
            "+1 664"
        ],
        [
            strictLocalize({
                id: "81wBxg",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Northern Mariana Islands"
                    }
                ]
            }),
            "+1 670"
        ],
        [
            strictLocalize({
                id: "9Zf8mS",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Guam"
                    }
                ]
            }),
            "+1 671"
        ],
        [
            strictLocalize({
                id: "H0s7s8",
                defaultMessage: [
                    {
                        type: 0,
                        value: "American Samoa"
                    }
                ]
            }),
            "+1 684"
        ],
        [
            strictLocalize({
                id: "ReQj7p",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sint Maarten (Netherlands)"
                    }
                ]
            }),
            "+1 721"
        ],
        [
            strictLocalize({
                id: "7hVOqu",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Saint Lucia"
                    }
                ]
            }),
            "+1 758"
        ],
        [
            strictLocalize({
                id: "tUS6JW",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Dominica"
                    }
                ]
            }),
            "+1 767"
        ],
        [
            strictLocalize({
                id: "i0lO/c",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Saint Vincent and the Grenadines"
                    }
                ]
            }),
            "+1 784"
        ],
        [
            strictLocalize({
                id: "WZL5+6",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Puerto Rico"
                    }
                ]
            }),
            "+1 787"
        ],
        [
            strictLocalize({
                id: "WZL5+6",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Puerto Rico"
                    }
                ]
            }),
            "+1 939"
        ],
        [
            strictLocalize({
                id: "isvxDa",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Midway Island, USA"
                    }
                ]
            }),
            "+1 808"
        ],
        [
            strictLocalize({
                id: "gqp8S4",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Wake Island, USA"
                    }
                ]
            }),
            "+1 808"
        ],
        [
            strictLocalize({
                id: "ju2vxd",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Dominican Republic"
                    }
                ]
            }),
            "+1 809"
        ],
        [
            strictLocalize({
                id: "ju2vxd",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Dominican Republic"
                    }
                ]
            }),
            "+1 829"
        ],
        [
            strictLocalize({
                id: "ju2vxd",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Dominican Republic"
                    }
                ]
            }),
            "+1 849"
        ],
        [
            strictLocalize({
                id: "xn8xM4",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Trinidad and Tobago"
                    }
                ]
            }),
            "+1 868"
        ],
        [
            strictLocalize({
                id: "lD4A/L",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Nevis"
                    }
                ]
            }),
            "+1 869"
        ],
        [
            strictLocalize({
                id: "xolDde",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Saint Kitts and Nevis"
                    }
                ]
            }),
            "+1 869"
        ],
        [
            strictLocalize({
                id: "a2ZrwW",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Jamaica"
                    }
                ]
            }),
            "+1 876"
        ],
        [
            strictLocalize({
                id: "D/Ppv6",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Egypt"
                    }
                ]
            }),
            "+20"
        ],
        [
            strictLocalize({
                id: "FaX7kC",
                defaultMessage: [
                    {
                        type: 0,
                        value: "South Sudan"
                    }
                ]
            }),
            "+211"
        ],
        [
            strictLocalize({
                id: "Z55MLZ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Morocco"
                    }
                ]
            }),
            "+212"
        ],
        [
            strictLocalize({
                id: "cVydRP",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Algeria"
                    }
                ]
            }),
            "+213"
        ],
        [
            strictLocalize({
                id: "sV5eq+",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Tunisia"
                    }
                ]
            }),
            "+216"
        ],
        [
            strictLocalize({
                id: "jovoCv",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Libya"
                    }
                ]
            }),
            "+218"
        ],
        [
            strictLocalize({
                id: "8LDpiR",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Gambia"
                    }
                ]
            }),
            "+220"
        ],
        [
            strictLocalize({
                id: "MDZSbh",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Senegal"
                    }
                ]
            }),
            "+221"
        ],
        [
            strictLocalize({
                id: "h03L43",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Mauritania"
                    }
                ]
            }),
            "+222"
        ],
        [
            strictLocalize({
                id: "WJugug",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Mali"
                    }
                ]
            }),
            "+223"
        ],
        [
            strictLocalize({
                id: "UiXVBy",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Guinea"
                    }
                ]
            }),
            "+224"
        ],
        [
            strictLocalize({
                id: "DHDT29",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Ivory Coast"
                    }
                ]
            }),
            "+225"
        ],
        [
            strictLocalize({
                id: "XYrRbN",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Burkina Faso"
                    }
                ]
            }),
            "+226"
        ],
        [
            strictLocalize({
                id: "ujrhEp",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Niger"
                    }
                ]
            }),
            "+227"
        ],
        [
            strictLocalize({
                id: "0xnvyf",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Togo"
                    }
                ]
            }),
            "+228"
        ],
        [
            strictLocalize({
                id: "XrwfP2",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Benin"
                    }
                ]
            }),
            "+229"
        ],
        [
            strictLocalize({
                id: "vh5eoN",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Mauritius"
                    }
                ]
            }),
            "+230"
        ],
        [
            strictLocalize({
                id: "EsDIrc",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Liberia"
                    }
                ]
            }),
            "+231"
        ],
        [
            strictLocalize({
                id: "OfulrG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sierra Leone"
                    }
                ]
            }),
            "+232"
        ],
        [
            strictLocalize({
                id: "Gny8TN",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Ghana"
                    }
                ]
            }),
            "+233"
        ],
        [
            strictLocalize({
                id: "2kg4rp",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Nigeria"
                    }
                ]
            }),
            "+234"
        ],
        [
            strictLocalize({
                id: "sTLxl/",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Chad"
                    }
                ]
            }),
            "+235"
        ],
        [
            strictLocalize({
                id: "aNuPPr",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Central African Republic"
                    }
                ]
            }),
            "+236"
        ],
        [
            strictLocalize({
                id: "vVSyA1",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cameroon"
                    }
                ]
            }),
            "+237"
        ],
        [
            strictLocalize({
                id: "xz/4M8",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cape Verde"
                    }
                ]
            }),
            "+238"
        ],
        [
            strictLocalize({
                id: "hHfKju",
                defaultMessage: [
                    {
                        type: 0,
                        value: "S\u00E3o Tom\u00E9 and Pr\u00EDncipe"
                    }
                ]
            }),
            "+239"
        ],
        [
            strictLocalize({
                id: "kOJPz1",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Equatorial Guinea"
                    }
                ]
            }),
            "+240"
        ],
        [
            strictLocalize({
                id: "Jg0gqZ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Gabon"
                    }
                ]
            }),
            "+241"
        ],
        [
            strictLocalize({
                id: "LpXwZ0",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Congo"
                    }
                ]
            }),
            "+242"
        ],
        [
            strictLocalize({
                id: "NbZ9Nf",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Congo, Democratic Republic of the (Zaire)"
                    }
                ]
            }),
            "+243"
        ],
        [
            strictLocalize({
                id: "XmGInQ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Angola"
                    }
                ]
            }),
            "+244"
        ],
        [
            strictLocalize({
                id: "SnJ/sr",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Guinea-Bissau"
                    }
                ]
            }),
            "+245"
        ],
        [
            strictLocalize({
                id: "ph0LQB",
                defaultMessage: [
                    {
                        type: 0,
                        value: "British Indian Ocean Territory"
                    }
                ]
            }),
            "+246"
        ],
        [
            strictLocalize({
                id: "e93uBS",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Diego Garcia"
                    }
                ]
            }),
            "+246"
        ],
        [
            strictLocalize({
                id: "ZkyXh+",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Ascension"
                    }
                ]
            }),
            "+247"
        ],
        [
            strictLocalize({
                id: "DJ3RWa",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Seychelles"
                    }
                ]
            }),
            "+248"
        ],
        [
            strictLocalize({
                id: "gJtmCF",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sudan"
                    }
                ]
            }),
            "+249"
        ],
        [
            strictLocalize({
                id: "W9+hcP",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Rwanda"
                    }
                ]
            }),
            "+250"
        ],
        [
            strictLocalize({
                id: "6byKTD",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Ethiopia"
                    }
                ]
            }),
            "+251"
        ],
        [
            strictLocalize({
                id: "ylrEZs",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Somalia"
                    }
                ]
            }),
            "+252"
        ],
        [
            strictLocalize({
                id: "TyjdMl",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Djibouti"
                    }
                ]
            }),
            "+253"
        ],
        [
            strictLocalize({
                id: "IEYnV2",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Kenya"
                    }
                ]
            }),
            "+254"
        ],
        [
            strictLocalize({
                id: "5kCRBr",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Tanzania"
                    }
                ]
            }),
            "+255"
        ],
        [
            strictLocalize({
                id: "nmCcHj",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Zanzibar"
                    }
                ]
            }),
            "+255 24"
        ],
        [
            strictLocalize({
                id: "8V2yEJ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Uganda"
                    }
                ]
            }),
            "+256"
        ],
        [
            strictLocalize({
                id: "8T0MvX",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Burundi"
                    }
                ]
            }),
            "+257"
        ],
        [
            strictLocalize({
                id: "sfz6CP",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Mozambique"
                    }
                ]
            }),
            "+258"
        ],
        [
            strictLocalize({
                id: "sFUOTS",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Zambia"
                    }
                ]
            }),
            "+260"
        ],
        [
            strictLocalize({
                id: "eK/l1b",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Madagascar"
                    }
                ]
            }),
            "+261"
        ],
        [
            strictLocalize({
                id: "/qbSRa",
                defaultMessage: [
                    {
                        type: 0,
                        value: "R\u00E9union"
                    }
                ]
            }),
            "+262"
        ],
        [
            strictLocalize({
                id: "BuPTMG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Mayotte"
                    }
                ]
            }),
            "+262 269"
        ],
        [
            strictLocalize({
                id: "BuPTMG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Mayotte"
                    }
                ]
            }),
            "+262 639"
        ],
        [
            strictLocalize({
                id: "3mBRmW",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Namibia"
                    }
                ]
            }),
            "+264"
        ],
        [
            strictLocalize({
                id: "yNLtBy",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Malawi"
                    }
                ]
            }),
            "+265"
        ],
        [
            strictLocalize({
                id: "zi3st7",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Lesotho"
                    }
                ]
            }),
            "+266"
        ],
        [
            strictLocalize({
                id: "O7U96J",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Botswana"
                    }
                ]
            }),
            "+267"
        ],
        [
            strictLocalize({
                id: "s23Zkd",
                defaultMessage: [
                    {
                        type: 0,
                        value: "eSwatini"
                    }
                ]
            }),
            "+268"
        ],
        [
            strictLocalize({
                id: "ZqmWun",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Comoros"
                    }
                ]
            }),
            "+269"
        ],
        [
            strictLocalize({
                id: "KWj28m",
                defaultMessage: [
                    {
                        type: 0,
                        value: "South Africa"
                    }
                ]
            }),
            "+27"
        ],
        [
            strictLocalize({
                id: "noJU8X",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Saint Helena"
                    }
                ]
            }),
            "+290"
        ],
        [
            strictLocalize({
                id: "HdAM7Y",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Tristan da Cunha"
                    }
                ]
            }),
            "+290 8"
        ],
        [
            strictLocalize({
                id: "offXtT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Eritrea"
                    }
                ]
            }),
            "+291"
        ],
        [
            strictLocalize({
                id: "YzvI8J",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Aruba"
                    }
                ]
            }),
            "+297"
        ],
        [
            strictLocalize({
                id: "S3V64D",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Faroe Islands"
                    }
                ]
            }),
            "+298"
        ],
        [
            strictLocalize({
                id: "wXIXDe",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Greenland"
                    }
                ]
            }),
            "+299"
        ],
        [
            strictLocalize({
                id: "HuNX98",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Greece"
                    }
                ]
            }),
            "+30"
        ],
        [
            strictLocalize({
                id: "FGqLx6",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Gibraltar"
                    }
                ]
            }),
            "+350"
        ],
        [
            strictLocalize({
                id: "UfV/4S",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Iceland"
                    }
                ]
            }),
            "+354"
        ],
        [
            strictLocalize({
                id: "lR3OIj",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Albania"
                    }
                ]
            }),
            "+355"
        ],
        [
            strictLocalize({
                id: "8grvfp",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Malta"
                    }
                ]
            }),
            "+356"
        ],
        [
            strictLocalize({
                id: "DZEnJz",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cyprus"
                    }
                ]
            }),
            "+357"
        ],
        [
            strictLocalize({
                id: "Zr6MqB",
                defaultMessage: [
                    {
                        type: 0,
                        value: "\u00C5land Islands"
                    }
                ]
            }),
            "+358 18"
        ],
        [
            strictLocalize({
                id: "bKSmoT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Bulgaria"
                    }
                ]
            }),
            "+359"
        ],
        [
            strictLocalize({
                id: "SIz5yt",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Hungary"
                    }
                ]
            }),
            "+36"
        ],
        [
            strictLocalize({
                id: "NYm9PS",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Lithuania"
                    }
                ]
            }),
            "+370"
        ],
        [
            strictLocalize({
                id: "z6g6KS",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Latvia"
                    }
                ]
            }),
            "+371"
        ],
        [
            strictLocalize({
                id: "68F59w",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Estonia"
                    }
                ]
            }),
            "+372"
        ],
        [
            strictLocalize({
                id: "7404MX",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Moldova"
                    }
                ]
            }),
            "+373"
        ],
        [
            strictLocalize({
                id: "TDqDfo",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Transnistria"
                    }
                ]
            }),
            "+373 2"
        ],
        [
            strictLocalize({
                id: "TDqDfo",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Transnistria"
                    }
                ]
            }),
            "+373 5"
        ],
        [
            strictLocalize({
                id: "X9iRqs",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Armenia"
                    }
                ]
            }),
            "+374"
        ],
        [
            strictLocalize({
                id: "0VEulh",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Nagorno-Karabakh"
                    }
                ]
            }),
            "+374 47"
        ],
        [
            strictLocalize({
                id: "0VEulh",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Nagorno-Karabakh"
                    }
                ]
            }),
            "+374 97"
        ],
        [
            strictLocalize({
                id: "QPYRey",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Belarus"
                    }
                ]
            }),
            "+375"
        ],
        [
            strictLocalize({
                id: "8t5+Uu",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Andorra"
                    }
                ]
            }),
            "+376"
        ],
        [
            strictLocalize({
                id: "rvJX6U",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Monaco"
                    }
                ]
            }),
            "+377"
        ],
        [
            strictLocalize({
                id: "GYw+NW",
                defaultMessage: [
                    {
                        type: 0,
                        value: "San Marino"
                    }
                ]
            }),
            "+378"
        ],
        [
            strictLocalize({
                id: "GX53KN",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Ukraine"
                    }
                ]
            }),
            "+380"
        ],
        [
            strictLocalize({
                id: "XXc8UO",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Serbia"
                    }
                ]
            }),
            "+381"
        ],
        [
            strictLocalize({
                id: "412AkQ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Montenegro"
                    }
                ]
            }),
            "+382"
        ],
        [
            strictLocalize({
                id: "AZ3j5T",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Kosovo"
                    }
                ]
            }),
            "+383"
        ],
        [
            strictLocalize({
                id: "p6A8cT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Croatia"
                    }
                ]
            }),
            "+385"
        ],
        [
            strictLocalize({
                id: "DQxJLG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Slovenia"
                    }
                ]
            }),
            "+386"
        ],
        [
            strictLocalize({
                id: "RDRBNU",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Bosnia and Herzegovina"
                    }
                ]
            }),
            "+387"
        ],
        [
            strictLocalize({
                id: "2rjM3E",
                defaultMessage: [
                    {
                        type: 0,
                        value: "North Macedonia"
                    }
                ]
            }),
            "+389"
        ],
        [
            strictLocalize({
                id: "XTlkZO",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Vatican City"
                    }
                ]
            }),
            "+39"
        ],
        [
            strictLocalize({
                id: "QEr2Bk",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Romania"
                    }
                ]
            }),
            "+40"
        ],
        [
            strictLocalize({
                id: "+Szthq",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Czech Republic"
                    }
                ]
            }),
            "+420"
        ],
        [
            strictLocalize({
                id: "QB+rcu",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Slovakia"
                    }
                ]
            }),
            "+421"
        ],
        [
            strictLocalize({
                id: "v98LJw",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Liechtenstein"
                    }
                ]
            }),
            "+423"
        ],
        [
            strictLocalize({
                id: "HDwstn",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Guernsey"
                    }
                ]
            }),
            "+44 1481"
        ],
        [
            strictLocalize({
                id: "HDwstn",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Guernsey"
                    }
                ]
            }),
            "+44 7781"
        ],
        [
            strictLocalize({
                id: "HDwstn",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Guernsey"
                    }
                ]
            }),
            "+44 7839"
        ],
        [
            strictLocalize({
                id: "HDwstn",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Guernsey"
                    }
                ]
            }),
            "+44 7911"
        ],
        [
            strictLocalize({
                id: "Vq/TqX",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Jersey"
                    }
                ]
            }),
            "+44 1534"
        ],
        [
            strictLocalize({
                id: "1XxeCk",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Isle of Man"
                    }
                ]
            }),
            "+44 1624"
        ],
        [
            strictLocalize({
                id: "1XxeCk",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Isle of Man"
                    }
                ]
            }),
            "+44 7524"
        ],
        [
            strictLocalize({
                id: "1XxeCk",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Isle of Man"
                    }
                ]
            }),
            "+44 7624"
        ],
        [
            strictLocalize({
                id: "1XxeCk",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Isle of Man"
                    }
                ]
            }),
            "+44 7924"
        ],
        [
            strictLocalize({
                id: "BXlhVI",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Jan Mayen"
                    }
                ]
            }),
            "+47 79"
        ],
        [
            strictLocalize({
                id: "PlGZfN",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Svalbard"
                    }
                ]
            }),
            "+47 79"
        ],
        [
            strictLocalize({
                id: "5jYEfv",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Poland"
                    }
                ]
            }),
            "+48"
        ],
        [
            strictLocalize({
                id: "mlzyWw",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Falkland Islands"
                    }
                ]
            }),
            "+500"
        ],
        [
            strictLocalize({
                id: "FhM/K+",
                defaultMessage: [
                    {
                        type: 0,
                        value: "South Georgia and the South Sandwich Islands"
                    }
                ]
            }),
            "+500"
        ],
        [
            strictLocalize({
                id: "SML31+",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Belize"
                    }
                ]
            }),
            "+501"
        ],
        [
            strictLocalize({
                id: "nQgYk/",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Guatemala"
                    }
                ]
            }),
            "+502"
        ],
        [
            strictLocalize({
                id: "KcVd+u",
                defaultMessage: [
                    {
                        type: 0,
                        value: "El Salvador"
                    }
                ]
            }),
            "+503"
        ],
        [
            strictLocalize({
                id: "htBNcB",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Honduras"
                    }
                ]
            }),
            "+504"
        ],
        [
            strictLocalize({
                id: "grGuIG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Nicaragua"
                    }
                ]
            }),
            "+505"
        ],
        [
            strictLocalize({
                id: "Cq154j",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Costa Rica"
                    }
                ]
            }),
            "+506"
        ],
        [
            strictLocalize({
                id: "j8CV0d",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Panama"
                    }
                ]
            }),
            "+507"
        ],
        [
            strictLocalize({
                id: "PfyfU+",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Saint Pierre and Miquelon"
                    }
                ]
            }),
            "+508"
        ],
        [
            strictLocalize({
                id: "riqahN",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Haiti"
                    }
                ]
            }),
            "+509"
        ],
        [
            strictLocalize({
                id: "duoM3I",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Peru"
                    }
                ]
            }),
            "+51"
        ],
        [
            strictLocalize({
                id: "g8ciUo",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Mexico"
                    }
                ]
            }),
            "+52"
        ],
        [
            strictLocalize({
                id: "nKpfjO",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cuba"
                    }
                ]
            }),
            "+53"
        ],
        [
            strictLocalize({
                id: "zHg2hp",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Argentina"
                    }
                ]
            }),
            "+54"
        ],
        [
            strictLocalize({
                id: "I+ZZNe",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Brazil"
                    }
                ]
            }),
            "+55"
        ],
        [
            strictLocalize({
                id: "Cx0lJ4",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Chile"
                    }
                ]
            }),
            "+56"
        ],
        [
            strictLocalize({
                id: "RWCJEq",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Easter Island"
                    }
                ]
            }),
            "+56"
        ],
        [
            strictLocalize({
                id: "gsTqGH",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Colombia"
                    }
                ]
            }),
            "+57"
        ],
        [
            strictLocalize({
                id: "eESgKs",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Venezuela"
                    }
                ]
            }),
            "+58"
        ],
        [
            strictLocalize({
                id: "SwpJE9",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Guadeloupe"
                    }
                ]
            }),
            "+590"
        ],
        [
            strictLocalize({
                id: "UT0yB/",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Saint Barth\u00E9lemy"
                    }
                ]
            }),
            "+590"
        ],
        [
            strictLocalize({
                id: "ExyzYD",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Saint Martin (France)"
                    }
                ]
            }),
            "+590"
        ],
        [
            strictLocalize({
                id: "TPV2oj",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Bolivia"
                    }
                ]
            }),
            "+591"
        ],
        [
            strictLocalize({
                id: "aHys0N",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Guyana"
                    }
                ]
            }),
            "+592"
        ],
        [
            strictLocalize({
                id: "n3s7dF",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Ecuador"
                    }
                ]
            }),
            "+593"
        ],
        [
            strictLocalize({
                id: "kkkLZg",
                defaultMessage: [
                    {
                        type: 0,
                        value: "French Guiana"
                    }
                ]
            }),
            "+594"
        ],
        [
            strictLocalize({
                id: "9RWAyB",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Paraguay"
                    }
                ]
            }),
            "+595"
        ],
        [
            strictLocalize({
                id: "JnE/GX",
                defaultMessage: [
                    {
                        type: 0,
                        value: "French Antilles"
                    }
                ]
            }),
            "+596"
        ],
        [
            strictLocalize({
                id: "YGBzOr",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Martinique"
                    }
                ]
            }),
            "+596"
        ],
        [
            strictLocalize({
                id: "89Nh78",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Suriname"
                    }
                ]
            }),
            "+597"
        ],
        [
            strictLocalize({
                id: "UWoJCr",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Uruguay"
                    }
                ]
            }),
            "+598"
        ],
        [
            strictLocalize({
                id: "8CsqPY",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sint Eustatius"
                    }
                ]
            }),
            "+599 3"
        ],
        [
            strictLocalize({
                id: "TnQYXs",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Caribbean Netherlands"
                    }
                ]
            }),
            "+599 3"
        ],
        [
            strictLocalize({
                id: "TnQYXs",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Caribbean Netherlands"
                    }
                ]
            }),
            "+599 4"
        ],
        [
            strictLocalize({
                id: "TnQYXs",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Caribbean Netherlands"
                    }
                ]
            }),
            "+599 7"
        ],
        [
            strictLocalize({
                id: "R55jrX",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Saba"
                    }
                ]
            }),
            "+599 4"
        ],
        [
            strictLocalize({
                id: "3ZANb6",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Bonaire"
                    }
                ]
            }),
            "+599 7"
        ],
        [
            strictLocalize({
                id: "7RpRZs",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cura\u00E7ao"
                    }
                ]
            }),
            "+599 9"
        ],
        [
            strictLocalize({
                id: "4kKuzA",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Malaysia"
                    }
                ]
            }),
            "+60"
        ],
        [
            strictLocalize({
                id: "ICGVHw",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cocos (Keeling) Islands"
                    }
                ]
            }),
            "+61 89162"
        ],
        [
            strictLocalize({
                id: "8KIDLC",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Christmas Island"
                    }
                ]
            }),
            "+61 89164"
        ],
        [
            strictLocalize({
                id: "NLMHQ2",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Indonesia"
                    }
                ]
            }),
            "+62"
        ],
        [
            strictLocalize({
                id: "PZWwxZ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Philippines"
                    }
                ]
            }),
            "+63"
        ],
        [
            strictLocalize({
                id: "65AuhJ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Chatham Island, New Zealand"
                    }
                ]
            }),
            "+64"
        ],
        [
            strictLocalize({
                id: "SKXnHw",
                defaultMessage: [
                    {
                        type: 0,
                        value: "New Zealand"
                    }
                ]
            }),
            "+64"
        ],
        [
            strictLocalize({
                id: "0aedsC",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Pitcairn Islands"
                    }
                ]
            }),
            "+64"
        ],
        [
            strictLocalize({
                id: "Y/xl0q",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Singapore"
                    }
                ]
            }),
            "+65"
        ],
        [
            strictLocalize({
                id: "0OH65Y",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Thailand"
                    }
                ]
            }),
            "+66"
        ],
        [
            strictLocalize({
                id: "njVeTs",
                defaultMessage: [
                    {
                        type: 0,
                        value: "East Timor"
                    }
                ]
            }),
            "+670"
        ],
        [
            strictLocalize({
                id: "AvUDbS",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Australian External Territories"
                    }
                ]
            }),
            "+672"
        ],
        [
            strictLocalize({
                id: "xSqPk5",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Australian Antarctic Territory"
                    }
                ]
            }),
            "+672 1"
        ],
        [
            strictLocalize({
                id: "OQ6hDy",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Norfolk Island"
                    }
                ]
            }),
            "+672 3"
        ],
        [
            strictLocalize({
                id: "h70HHK",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Brunei Darussalam"
                    }
                ]
            }),
            "+673"
        ],
        [
            strictLocalize({
                id: "e99NUd",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Nauru"
                    }
                ]
            }),
            "+674"
        ],
        [
            strictLocalize({
                id: "9Z7mzY",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Papua New Guinea"
                    }
                ]
            }),
            "+675"
        ],
        [
            strictLocalize({
                id: "giOCva",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Tonga"
                    }
                ]
            }),
            "+676"
        ],
        [
            strictLocalize({
                id: "sETeyP",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Solomon Islands"
                    }
                ]
            }),
            "+677"
        ],
        [
            strictLocalize({
                id: "fxlKUL",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Vanuatu"
                    }
                ]
            }),
            "+678"
        ],
        [
            strictLocalize({
                id: "A2ZldL",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Fiji"
                    }
                ]
            }),
            "+679"
        ],
        [
            strictLocalize({
                id: "Wl0bum",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Palau"
                    }
                ]
            }),
            "+680"
        ],
        [
            strictLocalize({
                id: "4EfuY4",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Wallis and Futuna"
                    }
                ]
            }),
            "+681"
        ],
        [
            strictLocalize({
                id: "e+RI12",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cook Islands"
                    }
                ]
            }),
            "+682"
        ],
        [
            strictLocalize({
                id: "2UUJDf",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Niue"
                    }
                ]
            }),
            "+683"
        ],
        [
            strictLocalize({
                id: "gZ4ytO",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Samoa"
                    }
                ]
            }),
            "+685"
        ],
        [
            strictLocalize({
                id: "LS+Oey",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Kiribati"
                    }
                ]
            }),
            "+686"
        ],
        [
            strictLocalize({
                id: "+25aDR",
                defaultMessage: [
                    {
                        type: 0,
                        value: "New Caledonia"
                    }
                ]
            }),
            "+687"
        ],
        [
            strictLocalize({
                id: "JjZZ6Q",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Tuvalu"
                    }
                ]
            }),
            "+688"
        ],
        [
            strictLocalize({
                id: "7sk4Th",
                defaultMessage: [
                    {
                        type: 0,
                        value: "French Polynesia"
                    }
                ]
            }),
            "+689"
        ],
        [
            strictLocalize({
                id: "bEtgjp",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Tokelau"
                    }
                ]
            }),
            "+690"
        ],
        [
            strictLocalize({
                id: "apDY3i",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Micronesia, Federated States of"
                    }
                ]
            }),
            "+691"
        ],
        [
            strictLocalize({
                id: "ONEK14",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Marshall Islands"
                    }
                ]
            }),
            "+692"
        ],
        [
            strictLocalize({
                id: "ZZuL4Z",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Kazakhstan"
                    }
                ]
            }),
            "+7 6"
        ],
        [
            strictLocalize({
                id: "ZZuL4Z",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Kazakhstan"
                    }
                ]
            }),
            "+7 7"
        ],
        [
            strictLocalize({
                id: "pksKmC",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Russia"
                    }
                ]
            }),
            "+7"
        ],
        [
            strictLocalize({
                id: "9IiSVk",
                defaultMessage: [
                    {
                        type: 0,
                        value: "International Freephone Service (UIFN)"
                    }
                ]
            }),
            "+800"
        ],
        [
            strictLocalize({
                id: "4Vg4o2",
                defaultMessage: [
                    {
                        type: 0,
                        value: "International Shared Cost Service (ISCS)"
                    }
                ]
            }),
            "+808"
        ],
        [
            strictLocalize({
                id: "9S6XqK",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Japan"
                    }
                ]
            }),
            "+81"
        ],
        [
            strictLocalize({
                id: "cQeV/2",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Korea, South"
                    }
                ]
            }),
            "+82"
        ],
        [
            strictLocalize({
                id: "64OLRM",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Vietnam"
                    }
                ]
            }),
            "+84"
        ],
        [
            strictLocalize({
                id: "P009eC",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Korea, North"
                    }
                ]
            }),
            "+850"
        ],
        [
            strictLocalize({
                id: "KXDPyP",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Hong Kong"
                    }
                ]
            }),
            "+852"
        ],
        [
            strictLocalize({
                id: "uQjX+x",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Macau"
                    }
                ]
            }),
            "+853"
        ],
        [
            strictLocalize({
                id: "Lht/BN",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Cambodia"
                    }
                ]
            }),
            "+855"
        ],
        [
            strictLocalize({
                id: "3z+UQR",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Laos"
                    }
                ]
            }),
            "+856"
        ],
        [
            strictLocalize({
                id: "KqFmIe",
                defaultMessage: [
                    {
                        type: 0,
                        value: "China"
                    }
                ]
            }),
            "+86"
        ],
        [
            strictLocalize({
                id: "rlFQby",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Inmarsat SNAC"
                    }
                ]
            }),
            "+870"
        ],
        [
            strictLocalize({
                id: "OOnz++",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Universal Personal Telecommunications (UPT)"
                    }
                ]
            }),
            "+878"
        ],
        [
            strictLocalize({
                id: "J9rXcH",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Bangladesh"
                    }
                ]
            }),
            "+880"
        ],
        [
            strictLocalize({
                id: "PTL/DT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Global Mobile Satellite System (GMSS)"
                    }
                ]
            }),
            "+881"
        ],
        [
            strictLocalize({
                id: "WzwLPu",
                defaultMessage: [
                    {
                        type: 0,
                        value: "ICO Global (Mobile Satellite Service)"
                    }
                ]
            }),
            "+881 0"
        ],
        [
            strictLocalize({
                id: "WzwLPu",
                defaultMessage: [
                    {
                        type: 0,
                        value: "ICO Global (Mobile Satellite Service)"
                    }
                ]
            }),
            "+881 1"
        ],
        [
            strictLocalize({
                id: "LLatV8",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Ellipso (Mobile Satellite service)"
                    }
                ]
            }),
            "+881 2"
        ],
        [
            strictLocalize({
                id: "LLatV8",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Ellipso (Mobile Satellite service)"
                    }
                ]
            }),
            "+881 3"
        ],
        [
            strictLocalize({
                id: "uWCBs3",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Iridium (Mobile Satellite service)"
                    }
                ]
            }),
            "+881 6"
        ],
        [
            strictLocalize({
                id: "uWCBs3",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Iridium (Mobile Satellite service)"
                    }
                ]
            }),
            "+881 7"
        ],
        [
            strictLocalize({
                id: "sfuueK",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Globalstar (Mobile Satellite Service)"
                    }
                ]
            }),
            "+881 8"
        ],
        [
            strictLocalize({
                id: "sfuueK",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Globalstar (Mobile Satellite Service)"
                    }
                ]
            }),
            "+881 9"
        ],
        [
            strictLocalize({
                id: "6Lm8ZG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "EMSAT (Mobile Satellite service)"
                    }
                ]
            }),
            "+882 13"
        ],
        [
            strictLocalize({
                id: "tN+ptB",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Thuraya (Mobile Satellite service)"
                    }
                ]
            }),
            "+882 16"
        ],
        [
            strictLocalize({
                id: "W5C2be",
                defaultMessage: [
                    {
                        type: 0,
                        value: "International Networks"
                    }
                ]
            }),
            "+882"
        ],
        [
            strictLocalize({
                id: "W5C2be",
                defaultMessage: [
                    {
                        type: 0,
                        value: "International Networks"
                    }
                ]
            }),
            "+883"
        ],
        [
            strictLocalize({
                id: "gIRGTc",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Taiwan"
                    }
                ]
            }),
            "+886"
        ],
        [
            strictLocalize({
                id: "woMJTN",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Telecommunications for Disaster Relief by OCHA"
                    }
                ]
            }),
            "+888"
        ],
        [
            strictLocalize({
                id: "3DP3fr",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Turkey"
                    }
                ]
            }),
            "+90"
        ],
        [
            strictLocalize({
                id: "Pr2bu8",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Northern Cyprus"
                    }
                ]
            }),
            "+90 392"
        ],
        [
            strictLocalize({
                id: "vj3IBj",
                defaultMessage: [
                    {
                        type: 0,
                        value: "India"
                    }
                ]
            }),
            "+91"
        ],
        [
            strictLocalize({
                id: "BJ4eDp",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Pakistan"
                    }
                ]
            }),
            "+92"
        ],
        [
            strictLocalize({
                id: "lDR7ZS",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Afghanistan"
                    }
                ]
            }),
            "+93"
        ],
        [
            strictLocalize({
                id: "EYY757",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sri Lanka"
                    }
                ]
            }),
            "+94"
        ],
        [
            strictLocalize({
                id: "H6DRz0",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Myanmar"
                    }
                ]
            }),
            "+95"
        ],
        [
            strictLocalize({
                id: "en/R7w",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Maldives"
                    }
                ]
            }),
            "+960"
        ],
        [
            strictLocalize({
                id: "Gux60b",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Lebanon"
                    }
                ]
            }),
            "+961"
        ],
        [
            strictLocalize({
                id: "ijWalZ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Jordan"
                    }
                ]
            }),
            "+962"
        ],
        [
            strictLocalize({
                id: "1HaZ1w",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Syria"
                    }
                ]
            }),
            "+963"
        ],
        [
            strictLocalize({
                id: "Y3N3uU",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Iraq"
                    }
                ]
            }),
            "+964"
        ],
        [
            strictLocalize({
                id: "sXYQvs",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Kuwait"
                    }
                ]
            }),
            "+965"
        ],
        [
            strictLocalize({
                id: "gN6qmy",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Saudi Arabia"
                    }
                ]
            }),
            "+966"
        ],
        [
            strictLocalize({
                id: "kfCur7",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Yemen"
                    }
                ]
            }),
            "+967"
        ],
        [
            strictLocalize({
                id: "0MNdNx",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Oman"
                    }
                ]
            }),
            "+968"
        ],
        [
            strictLocalize({
                id: "pdvZEh",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Palestine, State of"
                    }
                ]
            }),
            "+970"
        ],
        [
            strictLocalize({
                id: "M3Wbwb",
                defaultMessage: [
                    {
                        type: 0,
                        value: "United Arab Emirates"
                    }
                ]
            }),
            "+971"
        ],
        [
            strictLocalize({
                id: "Is2UWO",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Israel"
                    }
                ]
            }),
            "+972"
        ],
        [
            strictLocalize({
                id: "0g1E1F",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Bahrain"
                    }
                ]
            }),
            "+973"
        ],
        [
            strictLocalize({
                id: "ruTiVI",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Qatar"
                    }
                ]
            }),
            "+974"
        ],
        [
            strictLocalize({
                id: "tqH411",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Bhutan"
                    }
                ]
            }),
            "+975"
        ],
        [
            strictLocalize({
                id: "AnvWtF",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Mongolia"
                    }
                ]
            }),
            "+976"
        ],
        [
            strictLocalize({
                id: "j0n7e4",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Nepal"
                    }
                ]
            }),
            "+977"
        ],
        [
            strictLocalize({
                id: "tZDba5",
                defaultMessage: [
                    {
                        type: 0,
                        value: "International Premium Rate Service"
                    }
                ]
            }),
            "+979"
        ],
        [
            strictLocalize({
                id: "R28MbT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Iran"
                    }
                ]
            }),
            "+98"
        ],
        [
            strictLocalize({
                id: "EviMS7",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Tajikistan"
                    }
                ]
            }),
            "+992"
        ],
        [
            strictLocalize({
                id: "Eh7dES",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Turkmenistan"
                    }
                ]
            }),
            "+993"
        ],
        [
            strictLocalize({
                id: "JKAGC4",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Azerbaijan"
                    }
                ]
            }),
            "+994"
        ],
        [
            strictLocalize({
                id: "euos5F",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Georgia"
                    }
                ]
            }),
            "+995"
        ],
        [
            strictLocalize({
                id: "luMVj1",
                defaultMessage: [
                    {
                        type: 0,
                        value: "South Ossetia"
                    }
                ]
            }),
            "+995 34"
        ],
        [
            strictLocalize({
                id: "ME6CVy",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Kyrgyzstan"
                    }
                ]
            }),
            "+996"
        ],
        [
            strictLocalize({
                id: "8zWpCx",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Uzbekistan"
                    }
                ]
            }),
            "+998"
        ]
    ];
};
